"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
require("../../styles.css");
const SohoInfo = () => (react_1.default.createElement(react_1.Fragment, null,
    react_1.default.createElement("h3", { className: 'message-title' },
        'Don\'t',
        " see your app?"),
    react_1.default.createElement("div", { className: 'search-container' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Avalara connects with 700+ marketplaces, ERPs, and apps for ecommerce and bookkeeping."),
            react_1.default.createElement("a", { href: 'https://www.avalara.com/us/en/products/integrations.html', target: '_blank', rel: 'noopener noreferrer' }, "Browse integrations"))),
    react_1.default.createElement("div", null)));
exports.default = SohoInfo;
